class AdditionalProductCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this;
    this.swiper = this.section.querySelector(".swiper");
    this.next = this.section.querySelector(".swiper-button-next");
    this.prev = this.section.querySelector(".swiper-button-prev");
    this.pagination = this.section.querySelector(".swiper-pagination");

    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Navigation, Pagination } = _ref;
      this.slider = new Swiper(this.swiper, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: this.pagination,
          type: "bullets",
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 10,
            navigation: {
              nextEl: this.next,
              prevEl: this.prev,
            },
          },
        },
      });
    });
  }
  disconnectedCallback() {}
}
customElements.define("additional-product-carousel", AdditionalProductCarousel);

class AdditionalProductAddToCart extends HTMLElement {
  constructor() {
    super();
    this.addedProductText = "ADDED TO THE BAG";
    this.addingProductText = "ADDING TO THE BAG";
  }

  connectedCallback() {
    this.section = this;
    this.button = this.section.querySelector(".btn");

    this.button.addEventListener("click", this.buttonEventHandler.bind(this));
  }

  disconnectedCallback() {
    this.button.removeEventListener(
      "click",
      this.buttonEventHandler.bind(this)
    );
  }

  buttonEventHandler(event) {
    const button = event.target.closest(".btn");
    if (!button) return;
    const { variantId } = button.dataset;
    this.addToCart(variantId);
  }

  async addToCart(variantId) {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    this.button.innerHTML = this.addingProductText;

    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.log(`AdditionalProductAddToCart | ${error.message}`);
    } finally {
      this.button.innerHTML = this.addedProductText;
      this.button.disabled = true;
    }
  }
}
customElements.define(
  "additional-product-item-add-to-cart",
  AdditionalProductAddToCart
);
